import { MapOverlayCloseButtonContainer, StyledCloseIcon } from "./MapOverlayCloseButton.styles";

interface MapOverlayCloseButtonProps {
  onClose: () => void;
}

const MapOverlayCloseButton: React.FC<MapOverlayCloseButtonProps> = ({ onClose }: MapOverlayCloseButtonProps) => (
  <MapOverlayCloseButtonContainer>
    <StyledCloseIcon onClick={onClose} aria-label="Cancel" data-testid="close-button" />
  </MapOverlayCloseButtonContainer>
);

export default MapOverlayCloseButton;
